import fs from 'node:fs'
import { toStrictJson } from '@cli-utils/files.js'

export function cleanTsconfig(tsconfigPath: string, aliasRoot = '@admin'): string[] {
  if (!fs.existsSync(tsconfigPath)) return []

  const raw = fs.readFileSync(tsconfigPath, 'utf-8')
  const stripped = toStrictJson(raw)

  let tsconfig: Record<string, unknown>
  try {
    tsconfig = JSON.parse(stripped)
  } catch {
    return []
  }

  const compilerOptions = (tsconfig.compilerOptions ?? {}) as Record<string, unknown>
  const paths = (compilerOptions.paths ?? {}) as Record<string, string[]>

  const removed: string[] = []
  for (const key of Object.keys(paths)) {
    if (
      key.startsWith('@admin/') ||
      key === '@admin/*' ||
      key.startsWith(`${aliasRoot}/`) ||
      key === `${aliasRoot}/*`
    ) {
      removed.push(key)
      delete paths[key]
    }
  }

  if (removed.length === 0) return []

  if (Object.keys(paths).length === 0) {
    compilerOptions.paths = undefined
  } else {
    compilerOptions.paths = paths
  }
  tsconfig.compilerOptions = compilerOptions

  fs.writeFileSync(tsconfigPath, `${JSON.stringify(tsconfig, null, 2)}\n`, 'utf-8')
  return removed
}
